import { defineStore } from 'pinia'
import { ref } from 'vue'
import { InternalTransferCountResponse } from '@/types'
import { useAxios } from '@/composables/useAxios'
import { STATUS_CODES } from '@/constants'
import { handleAxiosError } from '@/composables/useAxiosError'

export const useInternalTransferStore = defineStore('internalTransfer', () => {
  const pendingCount = ref(0)

  async function fetchPendingCount() {
    try {
      const res = await useAxios<null, { count: number }>('GET', '/domain/internal-transfer/count', true)
      if (res && res.status === STATUS_CODES.OK) {
        const parsed = InternalTransferCountResponse.safeParse(res.data)
        if (parsed.success) {
          pendingCount.value = parsed.data.count
        }
      }
    } catch (error) {
      handleAxiosError(error, { logPrefix: 'InternalTransferStore:fetchPendingCount' })
    }
  }

  function setPendingCount(count: number) {
    pendingCount.value = count
  }

  function decrementPendingCount() {
    if (pendingCount.value > 0) {
      pendingCount.value--
    }
  }

  function getPendingCount() {
    return pendingCount.value
  }

  return {
    pendingCount,
    fetchPendingCount,
    setPendingCount,
    decrementPendingCount,
    getPendingCount
  }
})
